export { default } from './equipment-search-items-list';
